import { Routes } from '@angular/router';
import { AuthGuard, NoAccessGuard, PermissionGuard } from '@ccfx/shared-lib';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { userOnboardingSubmittedGuard } from './guards/user-onboarding-submitted.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'onboarding',
    redirectTo: 'onboarding/business-info',
    pathMatch: 'full',
  },
  {
    path: 'onboarding/:step',
    loadComponent: () =>
      import('./features/onboarding/components/onboarding-shell/onboarding-shell').then(
        (m) => m.OnboardingShellComponent,
      ),
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'user-onboarding',
    redirectTo: 'user-onboarding/personal-info',
    pathMatch: 'full',
  },
  {
    path: 'user-onboarding/:step',
    loadComponent: () =>
      import('./features/user-onboarding/components/user-onboarding-shell/user-onboarding-shell').then(
        (m) => m.UserOnboardingShellComponent,
      ),
    canMatch: [PermissionGuard],
    canActivate: [AuthGuard, PermissionGuard, userOnboardingSubmittedGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./features/home/components/home/home').then((m) => m.HomeComponent),
    canMatch: [PermissionGuard],
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'dashboard',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'order-management',
    loadComponent: () =>
      import('./features/order-management/components/order-management-shell/order-management-shell').then(
        (m) => m.OrderManagementShellComponent,
      ),
    canMatch: [PermissionGuard],
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'order-management/:id',
    loadComponent: () =>
      import('./features/order-management/components/order-management-shell/order-management-shell').then(
        (m) => m.OrderManagementShellComponent,
      ),
    canMatch: [PermissionGuard],
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'shipping-fees',
    loadComponent: () =>
      import('./features/shipping-fees/components/shipping-fees/shipping-fees').then(
        (m) => m.ShippingFeesComponent,
      ),
    canMatch: [PermissionGuard],
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'rates',
    loadComponent: () =>
      import('./features/rates/components/rates/rates').then((m) => m.RatesComponent),
    canMatch: [PermissionGuard],
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('./features/terms-and-conditions/components/terms-and-conditions/terms-and-conditions').then(
        (m) => m.TermsAndConditionsComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'user-management',
    loadComponent: () =>
      import('./features/user-management/components/user-management-shell/user-management-shell').then(
        (m) => m.UserManagementShellComponent,
      ),
    canMatch: [PermissionGuard],
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('@ccfx/shared-lib/layout').then((m) => m.LoginComponent),
  },

  {
    path: 'no-access',
    loadComponent: () => import('@ccfx/shared-lib').then((m) => m.NoAccess),
    canActivate: [NoAccessGuard],
  },
  {
    path: 'not-found',
    loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
